import { AxiosInstance } from "axios";
import { REGISTER_PATH } from "../lib/path";
import { RegisterDataResponse } from "./interfaces/RegisterInterface";
import HartyValidator from "../common/utils/HartyValidator";

class RegisterUseCase {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async createAccount(
    username: string,
    password: string,
    confirmPassword: string,
    email: string,
    firstName: string,
    lastName: string,
    age: number,
    gender: number
  ): Promise<RegisterDataResponse> {
    try {
      HartyValidator.validateRegisterData(
        username,
        password,
        confirmPassword,
        email,
        firstName,
        lastName,
        age,
        gender
      );
      const response = await this.client.post(REGISTER_PATH, {
        username: username,
        password: password,
        email: email,
        first_name: firstName,
        last_name: lastName,
        age: age,
        gender: gender,
      });

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  async verifyAccount(username, verificationCode) {
    try {
      const response = await this.client.put(REGISTER_PATH, "", {
        params: { username: username, "verification-code": verificationCode },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }

  async sendVerificationCode(username) {
    try {
      const response = await this.client.get(REGISTER_PATH, {
        params: { username },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
}

export default RegisterUseCase;
